/**
 * Create jQuery UI datepickers with some defaults
 * @example
	$_GP.fn.datepicker('#form input', {
		minDate: "0D",
		changeMonth: true,
		changeYear: true,
	});
 * @param {string|jQuery} elm - base element
 * @param {object} opt - jQuery UI datepicker options
 * @returns {object} jQuery datepicker object
 */
$_GP.fn.datepicker = function(elm, opt) {

	elm = elm instanceof jQuery ? elm : $(elm);
	if (!elm.length) return;

	var defaults = {
		prevText: "&#xf104;",
		nextText: "&#xf105;",
		dateFormat: 'dd-mm-yy',
		duration: 'fast'
	};

	var options = $.extend({}, defaults, opt);

	return elm.datepicker(options).on('focus', function(){
		$(this).trigger('blur');
	});
};
